import { render, staticRenderFns } from "./violationPointsRecord.vue?vue&type=template&id=421e2541&scoped=true"
import script from "./violationPointsRecord.vue?vue&type=script&lang=js"
export * from "./violationPointsRecord.vue?vue&type=script&lang=js"
import style0 from "./violationPointsRecord.vue?vue&type=style&index=0&id=421e2541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e2541",
  null
  
)

export default component.exports